export default __webpack_public_path__ + "static/media/friendly.39b98745.svg";